import { API, Auth } from 'aws-amplify';

import { authConstants } from './types';

export const authActions = {
    removeCurrentUser,
    getCurrentUser,
};

function getCurrentUser() {
    return dispatch => {
        dispatch(request());

        authorizeCurrentUser()
            .then(({ user }) => dispatch(success(user)))
            .catch(error => dispatch(failure(error)));
    };

    function request() {
        return { type: authConstants.GET_CURRENT_USER_REQUEST };
    }
    function success(user) {
        return { type: authConstants.GET_CURRENT_USER_SUCCESS, user };
    }
    function failure(error) {
        return { type: authConstants.GET_CURRENT_USER_FAIL, error };
    }
}

function removeCurrentUser() {
    return dispatch => {
        dispatch(request());

        Auth.signOut()
            .then(() => {
                dispatch(success());
                window.location.href = '/';
            })
            .catch(error => dispatch(failure(error)));
    };

    function request() {
        return { type: authConstants.DELETE_CURRENT_USER_REQUEST };
    }
    function success() {
        return { type: authConstants.DELETE_CURRENT_USER_SUCCESS };
    }
    function failure(error) {
        return { type: authConstants.DELETE_CURRENT_USER_FAIL, error };
    }
}

export const authorizeCurrentUser = async () => {
    const currentSession = await Auth.currentSession();
    const id = currentSession.idToken.payload['cognito:username'];
    const [user] = await API.get('adminUsersAPI', `/users/${id}`, {});
    if (!user || !user.enabled) {
        Auth.signOut();
        window.location.href = '/';
        throw new Error('User unauthorized');
    }
    return { currentSession, user };
};
